
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://brripffladqztihvuxts.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJycmlwZmZsYWRxenRpaHZ1eHRzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDExNjgwNDQsImV4cCI6MjA1Njc0NDA0NH0.UhMgZ036bp1lfPKAnEcAd2QVXj8LQVCOutOVhd_LII0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Initialize the client with storage configuration
export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
    },
    global: {
      headers: {
        'x-application-name': 'hoss-immo-admin',
      },
    },
  }
);

// Helper function to initialize storage bucket (call this once when app loads)
export const initializeStorage = async () => {
  try {
    const { error } = await supabase.functions.invoke('create-storage-bucket');
    if (error) {
      console.error('Error initializing storage:', error);
    }
  } catch (err) {
    console.error('Failed to initialize storage:', err);
  }
};
